import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { KpiChartPointMenuItem } from "../kpi-chart.models";

@Component({
  selector: "chart-point-menu",
  templateUrl: "chart-point-menu.component.html",
  styleUrls: ["chart-point-menu.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartPointMenuComponent {
  @Input()
  public menuItems: KpiChartPointMenuItem[];
}
